import React from "react";
import {
    Space,
    Row,
    Col,
    message,
    Image,
    Button,
    Modal,
    Tooltip,
    Drawer,
    Input,
    Tabs,
} from "antd";
import { observer } from "mobx-react";
import { StoreContext } from "../store/RootStore";
import { Link } from "react-router-dom";
import { CheckCircleOutlined, CloseOutlined } from "@ant-design/icons";

import withRouter from "../withRouter";
import ListTable from "./ListTable";
import CompanyStore from "../store/CompanyStore";
import refreshIcon from "../assets/images/NewDesign/refreshicon.svg";
import TicketAdd from "./TicketAdd";
import TicketStore from "../store/TicketStore";
import dayjs from "dayjs";


class TicketDetailsList extends React.Component {
    constructor(props, context) {
        super(props);
        this.state = {}

        this.columns = [
            {
                title: context.translate("_TICKET_ID_"),
                dataIndex: "ticketId",
                width: 8,
                ellipsis: {
                    showTitle: true,
                },
                render: (value, record) => {
                    return (
                        // <Tooltip placement="topLeft" title={value}>
                        <Link
                            style={{ color: "#2563EB", textDecoration: "none" }}
                            onClick={(e) => {
                                e.preventDefault();
                                this.onEdit(record);
                            }}
                        >
                            {value}
                        </Link>
                        // </Tooltip>
                    );
                },
            },
            {
                title: context.translate("_PRIORITY_"),
                dataIndex: "priority",
                width: 15,
                ellipsis: {
                    showTitle: true,
                },
                render: (value) => {
                    if (value === 1) {
                        return <div className="ticketList-priority-type-low">Low</div>;
                    } else if (value === 2) {
                        return <div className="ticketList-priority-type-medium">Medium</div>;
                    } else if (value === 3) {
                        return <div className="ticketList-priority-type-high">High</div>;
                    }
                }
            },
            {
                title: context.translate("_STATUS_"),
                dataIndex: "ticketStatus",
                width: 15,
                ellipsis: {
                    showTitle: true,
                },
                render: (value) => {
                    if (value === 1) {
                        return <div className="ticketList-status-type-open">Open</div>;
                    } else if (value === 2) {
                        return <div className="ticketList-status-type-inProgress">In Progress</div>;
                    } else if (value === 3) {
                        return <div className="ticketList-status-type-onHold">On Hold</div>;
                    } else if (value === 4) {
                        return <div className="ticketList-status-type-resolved">Resolved</div>;
                    } else if (value === 5) {
                        return <div className="ticketList-status-type-closed">Closed</div>;
                    }
                }
            },
            {
                title: context.translate("_RAISED_BY_"),
                dataIndex: "name",
                width: 15,
                ellipsis: {
                    showTitle: true,
                },
            },
            {
                title: context.translate("_RAISED_ON_"),
                dataIndex: "date",
                width: 15,
                ellipsis: {
                    showTitle: true,
                },
                render: (val) => {
                    if (val) {
                        return dayjs(val).format("DD-MM-YYYY");
                    } else {
                        return <></>
                    }
                }
            },
            {
                title: context.translate("_LAST_UPDATED_"),
                dataIndex: "updatedByDate",
                width: 15,
                ellipsis: {
                    showTitle: true,
                },
                render: (val) => {
                    if (val) {
                        return dayjs(val).format("DD-MM-YYYY");
                    } else {
                        return <></>
                    }
                }
            },
        ];
    }
    render() {
        return (<>
            <ListTable
                columns={this.columns}
                // dataSource={this.ticketStore.ticketDetails}
               
            />
        </>)
    }

}

TicketDetailsList.contextType = StoreContext;
export default observer(withRouter(TicketDetailsList));